import axios, { AxiosResponse } from 'axios';
import { accessTokenKey } from '../utils/constants';
import { getItem, removeItem } from '../utils/utils';
import { LOGINPATH } from '../routes/routePaths';
import { baseUrl } from './endpoints';

const client = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

// Attach token to every request
client.interceptors.request.use(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config: any) => {
    const token = getItem(accessTokenKey);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

client.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (error: any) => {
    if (error?.response?.status === 401) {
      removeItem(accessTokenKey);
      window.location.href = LOGINPATH;
      return error?.response?.data?.message;
    }
    return Promise.reject(error?.response?.data);
  },
);

export { client };
